import { useSelector as useReduxSelector } from 'react-redux';
import type { RootState } from 'app/store/reducers';

export function useSelector<TResult>(selector: (state: RootState) => TResult): TResult;
export function useSelector<TResult, TProps extends object>(
    selector: (state: RootState, props: TProps) => TResult,
    props: TProps
): TResult;
export function useSelector<TResult, TProps extends object>(
    selector: (state: RootState, props?: TProps) => TResult,
    props?: TProps
): TResult {
    const selectorToUse = (state: RootState) => selector(state, props ?? ({} as TProps));
    return useReduxSelector(selectorToUse);
}
